import React, { useEffect, useRef, useState } from "react";
import "./Signupnew.scss";
import SiginInContainer from "./siginInContainer";
import { useSelector } from "react-redux";


const Signupnew = ({ isOpen, onClose, signInPopupDesktop }: any) => {

 const isMobile = useSelector((state:any)=>state?.navigation?.isMobile)
 
 if (!isOpen) {
   return null;
 }
 
  return (
    <div className={"Signup-popup-container"}>
      <div className={isMobile ? "Signup-popup" : "Signup-popup-D"}>
       <SiginInContainer  isOpen={isOpen} onClose={onClose} signInPopupDesktop={signInPopupDesktop}/>
      </div>
    </div>
  );
};

export default Signupnew;
